<template>
  <div>
    <b-row>
      <b-col class="text-left">{{ address1.trim() }}</b-col>
    </b-row>
    <b-row>
      <b-col class="text-left">{{ address2.trim() }}</b-col>
    </b-row>
    <b-row>
      <b-col class="col-3">{{ city.trim() }}</b-col>
      <b-col class="col-1">{{ state.trim() }}</b-col>
      <b-col col-5>{{ zip.trim() }}</b-col>
    </b-row>
    <b-row>
      <b-col>{{ country.trim() }}</b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Address',
  props: [
    'address1',
    'address2',
    'city',
    'state',
    'zip',
    'country'
  ]
}
</script>

<style scoped>

</style>
